import { render, staticRenderFns } from "./deposit-tab.vue?vue&type=template&id=20e5e2e0&"
import script from "./deposit-tab.vue?vue&type=script&lang=js&"
export * from "./deposit-tab.vue?vue&type=script&lang=js&"
import style0 from "./deposit-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deposit-tab.vue"
export default component.exports